module.exports = __webpack_public_path__ + "img/note.bf1edfe3.png";